export default "__VITE_ASSET__CSKQmPVN__"